<tt-modal (cancel)="modalController.dismiss()">
  <tt-modal-title>What's new</tt-modal-title>

  <div class="card-container">
    @for (release of releases(); track release.releasedAt) {
      <ion-card data-test="whats-new-modal-card">
        <ion-card-header>
          <ion-card-title data-test="whats-new-modal-release-name">
            {{ release.name }}
          </ion-card-title>
          <ion-card-subtitle data-test="whats-new-modal-release-date">
            {{ release.releasedAt | date }}
          </ion-card-subtitle>
        </ion-card-header>

        <ion-card-content
          class="whats-new"
          data-test="whats-new-modal-description"
          [innerHTML]="release.descriptionHtml"
        />

        @if (release.images.length) {
          <ion-card-content class="images">
            @for (image of release.images; track image) {
              <img
                data-test="whats-new-modal-image"
                [ngSrc]="image.url"
                height="292"
                width="600"
                [alt]="image.name"
              />
            }
          </ion-card-content>
        }
      </ion-card>
    }
  </div>
</tt-modal>
